import { render, staticRenderFns } from "./InventoryReportList.vue?vue&type=template&id=5f4f4deb&scoped=true&"
import script from "./InventoryReportList.vue?vue&type=script&lang=js&"
export * from "./InventoryReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f4deb",
  null
  
)

export default component.exports